import React from 'react';
import Navbar from '../components/Navbar';
import UniversityFinder from '../components/UniversityFinder';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const UniversitiesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* Spacer for fixed navbar */}
      <div className="h-20"></div>
      <UniversityFinder />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default UniversitiesPage;
